'use client';
import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import CertificationBadge from './CertificationBadge';

export default function SafetyCertificationsCard() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bento-card bg-card border border-border rounded-lg reveal" style={{ transitionDelay: '200ms' }}>
      {/* Header — always visible, tappable on mobile */}
      <div className="flex items-center justify-between p-4 md:p-0 md:block">
        <h3 className="text-2xl font-bold text-foreground md:mb-8 md:ml-[21px]">Industry Certifications</h3>
        {/* Chevron toggle — only visible on mobile */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="md:hidden ml-4 flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center transition-transform duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse certifications' : 'Expand certifications'}
        >
          <Icon
            name="ChevronDownIcon"
            size={16}
            className="text-muted-foreground"
          />
        </button>
      </div>

      {/* Certifications: always visible on desktop, collapsible on mobile */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out md:max-h-none md:opacity-100 ${
          isExpanded ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 md:px-0 pb-4 md:pb-0">
          <div className="space-y-4">
            <CertificationBadge
              name="OSHA Compliance"
              logo="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80"
              description="Occupational Safety and Health Administration certified"
            />

            <CertificationBadge
              name="Avetta Certified"
              logo="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=200&q=80"
              description="Pre-qualified for major energy and telecom projects"
            />

            <CertificationBadge
              name="Veriforce"
              logo="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&q=80"
              description="Pipeline safety and compliance verified"
            />
          </div>

          <div className="mt-8 p-6 bg-success/10 border border-success/30 rounded-lg">
            <p className="text-sm text-foreground leading-relaxed">
              <strong className="text-success">Safety is non-negotiable.</strong> Our comprehensive safety program,
              ongoing training, and industry certifications ensure every project is completed without incidents.
              We maintain the highest standards because your team and our team deserve nothing less.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
